// extracted by mini-css-extract-plugin
module.exports = {"container":"_3V6UNzXFwMlPawMhL35d6S","visible":"_3ybJal-xXT71Vm-seDKBHO","cancelBtn":"_1vXt6Rbjp84UQY6u57vQb9","icon":"VfS-LUVEBxLNETxp6XguF","saveBtn":"dBJvEZTK6NqUDgxQ2m9gY"};